import React from 'react';
import { useFormContext } from 'react-hook-form';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import { TextBox, When } from 'UI/components/atoms';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { Endpoints } from 'UI/constants/endpoints';
import { UIStatus } from 'UI/constants/status';

import { COPIES, FORM_FIELDS_MAP } from './SendoverReasonsFields.constants';
import { VerticalStack } from './SendoverReasonsFields.styled';

export const SendoverReasonsFields = () => {
  const { errors, register } = useFormContext();
  const { state } = useFetchWithStatusV2({ endpoint: Endpoints.SendoverReasons });

  const hasError = Boolean(errors[FORM_FIELDS_MAP.SendoverReasons.key]);
  const sendoverReasons = state.status === UIStatus.Success ? state.results : [];
  const hasCatalogError = state.status === UIStatus.Error || state.status === UIStatus.Empty;

  return (
    <VerticalStack>
      <Typography variant="body2">{COPIES.subtitle}</Typography>

      <FormControl component="fieldset" error={hasError}>
        <FormGroup>
          <When condition={state.status === UIStatus.Loading}>
            <CircularProgress size={24} />
          </When>

          <When condition={hasCatalogError}>
            <EmptyPlaceholder title={strings.sendoutsV2.drawers.tabs.status.error} />
          </When>

          {sendoverReasons.map(reason => (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  name={FORM_FIELDS_MAP.SendoverReasons.key}
                  value={reason}
                  inputRef={register({
                    validate: value =>
                      (Array.isArray(value) && value.length > 0) || COPIES.errors.reasons
                  })}
                />
              }
              key={reason}
              label={reason}
            />
          ))}

          <When condition={hasError}>
            <FormHelperText>{errors[FORM_FIELDS_MAP.SendoverReasons.key]?.message}</FormHelperText>
          </When>
        </FormGroup>
      </FormControl>

      <TextBox
        inputRef={register()}
        label={COPIES.labels.comments}
        multiline
        name={FORM_FIELDS_MAP.Comments.key}
        placeholder={COPIES.labels.comments}
      />
    </VerticalStack>
  );
};
